import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getGroupFullInfo, updateGroup} from 'src/openapi/admin/apis/AccountGroupApi';
import {useAppDispatch} from 'src/store/hooks';

import type {AccountGroupFullInfo} from 'src/openapi/admin/models/AccountGroupFullInfo';

type Props = {
    groupId: number,
};

export const useEditGroup = ({groupId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getGroupFullInfo({groupId}),
    ), [groupId, apiDispatch]);

    const saveDispatchAction = useCallback((accountGroupFullInfo: AccountGroupFullInfo) => apiDispatch(updateGroup({
        groupId,
        accountGroupFullInfo,
    })), [groupId, apiDispatch]);

    return useCommonDataHook({
        getDispatchAction,
        saveDispatchAction,
        initValue: {
            accountId: 0,
            name: '',
            ownerId: 0,
            groupOnlyCollaboration: false,
            overridePrivacyPermission: false,
            groupPrivacyEnabled: false,
            enableMyGroupPrivacy: false,
        },
    });
};
